import { configureVf } from '@zyno-io/vue-foundation';
import { nextTick, ref, watch } from 'vue';

import { GlobalState } from './global';
import { serviceWorkerManager } from './shared/services/sw.manager';

export function useAppServiceWorker() {
    // Registration is explicit (not an import side effect) so lean entries like the embedded CX app
    // don't accidentally register /sw.js. The full app opts in here.
    serviceWorkerManager.register();

    watch(GlobalState.tenant, () => {
        serviceWorkerManager.postPageContext();
    });

    const isModalDisplayed = ref(false);
    configureVf({
        onOverlaysChanged() {
            nextTick(() => {
                isModalDisplayed.value = document.querySelector('.vf-modal') !== null;
            });
        }
    });
    watch(isModalDisplayed, isModalDisplayed => {
        serviceWorkerManager.postMessage('updatePageContext', { modalOpen: isModalDisplayed });
    });
}
